import { formatPct } from "../../dashboard/analytics";

export function DonutSeverity({ moderate, high, critical, total }) {
  const sum = moderate + high + critical;
  const safe = sum || 1;
  const m = (moderate / safe) * 100;
  const h = (high / safe) * 100;
  const gradient = `conic-gradient(
    var(--chart-moderate) 0% ${m}%,
    var(--chart-high) ${m}% ${m + h}%,
    var(--chart-critical) ${m + h}% 100%
  )`;

  return (
    <div className="donut-wrap">
      <div className="donut" style={{ background: gradient }}>
        <div className="donut__hole">
          <strong>{total}</strong>
          <span>assessments</span>
        </div>
      </div>
      <ul className="donut-legend">
        <li>
          <span className="dot dot--mod" /> Moderate {formatPct(moderate / safe)}
        </li>
        <li>
          <span className="dot dot--high" /> High {formatPct(high / safe)}
        </li>
        <li>
          <span className="dot dot--crit" /> Critical {formatPct(critical / safe)}
        </li>
      </ul>
    </div>
  );
}
